<mat-form-field floatLabel="never" [ngClass]="classField()">
  @if (checkIcon() && control().value === true) {
    <span matPrefix>
      <mat-icon color="accent" class="icon-small mr1">check</mat-icon>
    </span>
  }
  @if (checkIcon() && control().value === false) {
    <span matPrefix>
      <mat-icon color="warn" class="icon-small">clear</mat-icon>
    </span>
  }
  <mat-select placeholder="..." [formControl]="control()" (keyup.enter)="onEnter($event)" autocomplete="off">
    <mat-option [value]="true"><span translate>Yes</span></mat-option>
    <mat-option [value]="false"><span translate>No</span></mat-option>
  </mat-select>
</mat-form-field>